export default __webpack_public_path__ + "static/media/icon-pending.075ca638.svg";